import { render } from "./PayMix.vue?vue&type=template&id=4e7fc51a&scoped=true"
import script from "./PayMix.vue?vue&type=script&lang=js"
export * from "./PayMix.vue?vue&type=script&lang=js"

import "./PayMix.vue?vue&type=style&index=0&id=4e7fc51a&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e7fc51a"]])

export default __exports__